import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import AreaPage from "@/pages/AreaPage";
import Projects from "@/pages/Projects";
import Blog from "@/pages/Blog";
import NotFound from "@/pages/NotFound";
import { AuthProvider } from "@/crm/AuthContext";
import Login from "@/crm/Login";
import CrmShell from "@/crm/CrmShell";
import Dashboard from "@/crm/Dashboard";
import LeadDetail from "@/crm/LeadDetail";
import ContentManager from "@/crm/ContentManager";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/areas/:slug" element={<AreaPage />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/staff/login" element={<Login />} />
          <Route path="/staff" element={<CrmShell />}>
            <Route index element={<Dashboard />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="content" element={<ContentManager />} />
          </Route>
        </Routes>
      </AuthProvider>
      <Toaster theme="dark" position="top-right" richColors />
    </BrowserRouter>
  );
}
